var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9996 12.111C23.9996 18.7278 18.6165 24.1111 11.9998 24.1111C5.38314 24.1111 0 18.7278 0 12.111C0 5.49433 5.38314 0.111084 11.9998 0.111084C18.6165 0.111084 23.9996 5.49433 23.9996 12.111ZM22.357 12.111C22.3569 6.40001 17.7107 1.75379 11.9998 1.75379C6.28892 1.75379 1.64281 6.40012 1.64281 12.1109C1.64281 17.8221 6.28892 22.4683 11.9998 22.4684C17.7109 22.4683 22.357 17.8221 22.357 12.111ZM11.5498 17.2507C11.2291 17.5712 10.7091 17.5714 10.3883 17.2507L5.82958 12.6923C5.67549 12.538 5.58898 12.3293 5.58887 12.1113C5.58887 11.8934 5.67538 11.6846 5.82947 11.5306L10.3884 6.97175C10.5488 6.81154 10.759 6.73126 10.9692 6.73126C11.1794 6.73126 11.3896 6.81154 11.55 6.97186C11.8708 7.29252 11.8708 7.81271 11.55 8.13347L8.39307 11.2902L17.5331 11.2893C17.9867 11.2893 18.3543 11.6569 18.3544 12.1105C18.3544 12.5643 17.9868 12.9319 17.5332 12.932L8.39351 12.9329L11.5497 16.089C11.8707 16.4098 11.8707 16.9298 11.5498 17.2507Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.91f748ea8f9abb536a467239270882fe.svg";
export { ForwardRef as ReactComponent };